// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';
//import appConfig from "../../config/appConfig";

// HOOKS
import { useGetAgentsByAgency } from "../../hooks/useGetAgents";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import AgentsSection from "./AgentsSection";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
//import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
//import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";

interface AboutUsProps {
    agencyId: number;
    showAgents: boolean;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId, showAgents }) => {
    const { t } = useTranslation();
    //const partners = appConfig.content.partners;
    const { agents, loading: agentsLoading, error: agentsError } = useGetAgentsByAgency(agencyId);
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;
    if (agentsLoading && showAgents) return <LoadingIndicator />;
    if (agentsError && showAgents) console.error("Error fetching agents:", agentsError);

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400&display=swap" rel="stylesheet" />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.subHeaderTitle')} isSeo={true} />

            <main id="about-us-page" className="space-ptb position-relative">
                <div className="container-fluid w-special">
                    <div className="row align-items-center">
                        <div className="col-12 col-xl-8 mb-4 mb-xl-0">
                            <h2 dangerouslySetInnerHTML={{ __html: t('aboutUsPage.title') as string }} className="mb-4" />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }} />
                        </div>
                        <div className="col-12 col-xl-4 text-center">
                            <img className="img-fluid" src="/assets/images/altrePag/chi-siamo.png" alt={t('aboutUsPage.imageAlt1') as string} />
                        </div>
                    </div>
                    <AgentsSection
                        showAgents={showAgents}
                        agents={agents}
                        agentsLoading={agentsLoading}
                        agentsError={agentsError}
                    />
                </div>
            </main>
        </>
    );
};
export default AboutUs;